<mat-form-field appearance="fill" class="full-width">
  <mat-label translate>your_gender</mat-label>
  <mat-select [formControl]="genderControl">
    @for (genderInfo of availableGenders; track genderInfo) {
      <mat-option
        value="{{genderInfo.sex}}">
        <mat-icon class="sex-icon" ngClass="{{genderInfo.sex}}-icon" svgIcon="{{genderInfo.sex}}"></mat-icon>
        {{genderInfo.translateKey | translate}}
      </mat-option>
    }
  </mat-select>
  @if (genderControl.hasError('required')) {
    <mat-error translate>choose_a_gender</mat-error>
  }
</mat-form-field>